import type { CellBorders } from '@/hooks/useCellSelection';

// Pre-compute all 16 possible box-shadow strings at module load.
// Encoding: top=8, right=4, bottom=2, left=1
const SEL_COLOR = 'rgba(59, 130, 246, 0.55)';
const SHADOW_STRINGS: string[] = new Array(16);
for (let i = 0; i < 16; i++) {
  const t = !!(i & 8), r = !!(i & 4), b = !!(i & 2), l = !!(i & 1);
  if (t && r && b && l) {
    SHADOW_STRINGS[i] = `inset 0 0 0 1px ${SEL_COLOR}`;
  } else {
    const parts: string[] = [];
    if (t) parts.push(`inset 0 1px 0 0 ${SEL_COLOR}`);
    if (b) parts.push(`inset 0 -1px 0 0 ${SEL_COLOR}`);
    if (l) parts.push(`inset 1px 0 0 0 ${SEL_COLOR}`);
    if (r) parts.push(`inset -1px 0 0 0 ${SEL_COLOR}`);
    SHADOW_STRINGS[i] = parts.join(', ') || 'none';
  }
}

/** O(1) lookup: CellBorders → pre-computed CSS box-shadow string */
export function borderShadow(b: CellBorders): string {
  return SHADOW_STRINGS[(b.top ? 8 : 0) | (b.right ? 4 : 0) | (b.bottom ? 2 : 0) | (b.left ? 1 : 0)];
}

/* ── Selection color constants ── */

export const SELECTION_FILL = 'rgba(59, 130, 246, 0.06)';
export const ROW_HIGHLIGHT_SHADOW = 'inset 0 -1px 0 0 rgba(59, 130, 246, 0.45)';
export const HEADER_COL_SELECTED_SHADOW = '0 1px 0 0 rgba(59, 130, 246, 0.45)';
